import {
  validate,
  string,
  optional,
  object,
  objectProperties,
} from './utils/validate'
import fieldConfigSchemasByType from './fieldConfigSchemas'
import { permissionsSchema } from './permissionsSchema'
import type { FieldConfig } from '../types'

const validateCollectionId = validate('collectionId', string)
const validateDescription = validate('description', string)
const validateDisplayField = validate('displayField', string)
const validateDisplayName = validate('displayName', string)
const validateNamespace = validate('namespace', string)
const validateFieldKey = validate('fieldKey', string)
const validateFieldType = validate('config.type', string)
const validateOptionalFieldType = validate('config.type', optional(string))

const validateConfigProperties = (config: FieldConfig) =>
  validate(
    'config',
    objectProperties(
      (fieldConfigSchemasByType as any)[config.type as string] ||
        fieldConfigSchemasByType.default,
    ),
  )(config)
const validateConfigType = validate('config', object)
const validatePermissions = validate(
  'permissions',
  objectProperties(permissionsSchema),
)

export {
  validateCollectionId,
  validateDescription,
  validateDisplayField,
  validateDisplayName,
  validateNamespace,
  validateFieldKey,
  validateFieldType,
  validateOptionalFieldType,
  validateConfigProperties,
  validateConfigType,
  validatePermissions,
}
